import { useState, useEffect } from 'react';

import { useDisplayControls } from './firmware/useDisplayControls';
import { useGetWeatherData } from './weather/useGetWeatherData';

interface WeatherData {
  insideTemperature: string;
  outsideTemperature: string;
  weatherCondition: string;
}

export const useWeather = (): WeatherData => {
  const [weatherData, setWeatherData] = useState<WeatherData>({
    insideTemperature: '',
    outsideTemperature: '',
    weatherCondition: '',
  });

  const { getWeather } = useGetWeatherData();
  const { temperature } = useDisplayControls();

  useEffect(() => {
    temperature.execute();
  }, []);

  useEffect(() => {
    const fetchWeatherData = async () => {
      try {
        const realWeatherData = await getWeather();

        const internalTemp = temperature.data?.temperature;
        const internalTempF = internalTemp ? Math.round((internalTemp * 9) / 5 + 32) : null;

        setWeatherData({
          insideTemperature: internalTempF ? `${internalTempF}°F` : 'N/A',
          outsideTemperature: realWeatherData.todayHighLow.temperature || 'N/A',
          weatherCondition: realWeatherData.todayHighLow.condition || 'Unknown',
        });
      } catch (error) {
        console.error('Error fetching weather data:', error);
        setWeatherData({
          insideTemperature: 'N/A',
          outsideTemperature: 'N/A',
          weatherCondition: 'Unknown',
        });
      }
    };

    fetchWeatherData();

    const interval = setInterval(fetchWeatherData, 10 * 60 * 1000);
    return () => clearInterval(interval);
  }, [temperature.data]);

  return weatherData;
};
